var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 1.5127V4.26639C7.33341 4.63976 7.33341 4.82644 7.40608 4.96905C7.46999 5.09449 7.57198 5.19648 7.69742 5.26039C7.84003 5.33306 8.02671 5.33306 8.40008 5.33306H11.1538M7.33341 11.333H3.33341M8.66675 8.66634H3.33341M11.3334 6.65849V11.4663C11.3334 12.5864 11.3334 13.1465 11.1154 13.5743C10.9237 13.9506 10.6177 14.2566 10.2414 14.4484C9.81357 14.6663 9.25352 14.6663 8.13341 14.6663H3.86675C2.74664 14.6663 2.18659 14.6663 1.75877 14.4484C1.38244 14.2566 1.07648 13.9506 0.884735 13.5743C0.666748 13.1465 0.666748 12.5864 0.666748 11.4663V4.53301C0.666748 3.4129 0.666748 2.85285 0.884735 2.42503C1.07648 2.0487 1.38244 1.74274 1.75877 1.55099C2.18659 1.33301 2.74664 1.33301 3.86675 1.33301H6.00793C6.49711 1.33301 6.7417 1.33301 6.97188 1.38827C7.17595 1.43726 7.37104 1.51807 7.54998 1.62773C7.75182 1.75141 7.92477 1.92436 8.27067 2.27027L10.3962 4.39575C10.7421 4.74165 10.915 4.9146 11.0387 5.11644C11.1484 5.29538 11.2292 5.49047 11.2782 5.69454C11.3334 5.92472 11.3334 6.16931 11.3334 6.65849Z",
    stroke: "#395BA9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUncheck);
export default __webpack_public_path__ + "static/media/FileUncheck.2c7740b499eeb79370a52140a00a4c88.svg";
export { ForwardRef as ReactComponent };